import React from 'react';
import { Card, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  cardRoot: {
    minWidth: 275,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 41,
    paddingRight: 41,
  },
  smallSubtitleRow: {
    margin: '20px 0',
  },
  coverageTitle: {
    display: 'flex',
    alignItems: 'flex-start',
  },
});

type Props = {
  title?: string;
  smallSubtitle?: string;
  children?: React.ReactNode;
  imageTitle?: React.ReactNode;
};

const DefaultCard = ({
  children,
  title,
  smallSubtitle,
  imageTitle,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Card className={classes.cardRoot} elevation={0}>
      <Grid item className={classes.coverageTitle}>
        {imageTitle}
        <Grid
          container
          item
          spacing={1}
          direction="column"
          style={{ marginLeft: 0 }}
        >
          <Grid item>
            {typeof title !== 'undefined' && (
              <Typography style={{ fontSize: 19 }}>{title}</Typography>
            )}
          </Grid>
          <Grid item>
            {typeof smallSubtitle !== 'undefined' && (
              <div className={classes.smallSubtitleRow}>
                <Typography variant="caption">{smallSubtitle}</Typography>
              </div>
            )}
          </Grid>
        </Grid>
      </Grid>
      {children}
    </Card>
  );
};

export default DefaultCard;
